package com.essntl.features.proposal.ui.proposalhistory.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.ClipboardManager
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.historyLink
import com.essntl.features.proposal.domain.model.shareLink
import com.essntl.features.proposal.ui.allproposal.components.ProposalStatus
import com.essntl.features.proposal.ui.getPdfState
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewState
import com.essntl.toastmanager.IO
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.file.launch
import com.essntl.uikit.components.file.rememberFileSaverLauncher
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.iconbutton.tinted.EsSmallTintedIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.generated.resources.Res
import com.essntl.uikit.theme.Branding
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.ExperimentalCalfApi
import core.pdf.itinerary.ItineraryPdfState
import core.pdf.itinerary.createItineraryPdf
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.koin.compose.koinInject

@OptIn(ExperimentalCalfApi::class, ExperimentalResourceApi::class)
@Composable
fun ProposalActionButtonsRow(
    state: ProposalOverviewState,
    proposal: ProposalModel,
    onCopyProposalHistory: (ProposalModel) -> Unit,
    onEditProposal: (proposalId: String) -> Unit,
) {
    val proposalId = proposal.id
    val parentProposalId = proposal.proposalId
    val isLoading = state.getProposal.isLoading

    val scope = rememberCoroutineScope()
    val toastManager = koinInject<ToastManager>()

    var isSavePdfLoading by remember { mutableStateOf(false) }
    var exportPdfProgress by remember {
        mutableFloatStateOf(0f)
    }
    var exportPdfJob by remember {
        mutableStateOf<Job?>(null)
    }

    val fileSaverPicker = rememberFileSaverLauncher(
        onResult = { file ->
            if (file == null)
                return@rememberFileSaverLauncher

            scope.launch {
                toastManager.success(description = "Proposal saved as PDF")
            }
        },
    )

    val isPdfLoading = remember(
        isLoading,
        isSavePdfLoading,
    ) {
        isSavePdfLoading || isLoading
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.5f.spacing),
        modifier = Modifier
            .fillMaxWidth()
            .clip(
                RoundedCornerShape(
                    bottomStart = 24.dp,
                    bottomEnd = 24.dp,
                ),
            )
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                top = 1.5f.spacing,
                bottom = 2.5f.spacing,
            )
            .padding(
                horizontal = 2.5f.spacing,
            ),
    ) {
        val uriHandler = LocalUriHandler.current

        val enabled = if (parentProposalId != null) {
            true
        } else {
            proposal.isPublished
        }

        val toolTipText = if (proposal.version > 1) "Open in web browser" else "Proposal not published yet"

        proposal.status?.let { status ->
            ProposalStatus(
                status = status,
            )
        }

        EsTooltip(
            text = toolTipText,
        ) {
            EsSmallOutlineIconButton(
                onClick = {
                    uriHandler.openUri(
                        uri = if (parentProposalId == null) proposal.shareLink else proposal.historyLink,
                    )
                },
                iconRes = EsIcons.Browse,
                enabled = !isLoading && enabled,
                modifier = Modifier
                    .alpha(if (enabled) 1f else 0.6f),
            )
        }

        if (parentProposalId == null) {
            EsTooltip(
                text = "Edit",
            ) {
                EsSmallPrimaryIconButton(
                    onClick = {
                        onEditProposal(proposalId)
                    },
                    iconRes = EsIcons.Edit,
                    enabled = !isLoading,
                )
            }

        } else {
            EsTooltip(
                text = "Make a copy",
            ) {
                EsSmallOutlineIconButton(
                    onClick = {
                        onCopyProposalHistory(proposal)
                    },
                    iconRes = EsIcons.Copy,
                    enabled = !isLoading && state.proposalParentStatus != ProposalModel.Status.Confirmed,
                )
            }
        }

        Spacer(modifier = Modifier.weight(1f))

        if (!isLoading && proposal.version > 0)
            Text(
                text = "v${proposal.version}",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )
    }
}